// extracted by mini-css-extract-plugin
module.exports = {"cta":"CTABlock_cta__sBkkb","container":"CTABlock_container__1dx1I","roundedCorners":"CTABlock_roundedCorners__P2YEe"};